<app-preloader
   *ngIf="showPreloader()"
  (finished)="hidePreloader()"
></app-preloader>

<router-outlet />

<app-emoji-trail />
